/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-02-24 14:10:55
 * @LastEditors: Gao Deng gaodeng@nextmar.com
 * @LastEditTime: 2025-04-22 01:29:48
 * @FilePath: /zeelool-nextjs/src/providers/app-store-provider.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
'use client';

import { createContext, type ReactNode, useContext, useEffect, useRef } from 'react';
import { type StoreApi, useStore as useZustandStore } from 'zustand';

import { createAppStore, Store } from '@/store';
import { StoreState } from '@/store/defaultState';
import { setStoreAccessor } from '@/utils/logout';
import { useShallow } from 'zustand/react/shallow';

export const AppStoreContext = createContext<StoreApi<Store> | null>(null);

export interface AppStoreProviderProps {
  children: ReactNode;
  /**
   * Store 的初始数据（从服务端传入）
   * 在 Store 创建时使用，确保子组件第一次渲染就能读到正确的值
   */
  initialData?: Partial<StoreState>;
}

// Window interface已在index.d.ts中统一定义
export const AppStoreProvider = ({ children, initialData }: AppStoreProviderProps) => {
  const storeRef = useRef<StoreApi<Store> | null>(null);

  if (!storeRef.current) {
    storeRef.current = createAppStore(initialData);
  }

  // 设置store访问器，用于在非组件环境中访问store
  useEffect(() => {
    if (storeRef.current) {
      // 返回 store 的 getState() 结果，它包含了所有的 actions 和 state
      const store = storeRef.current;
      setStoreAccessor(() => store.getState());
    }
  }, []);

  return <AppStoreContext.Provider value={storeRef.current}>{children}</AppStoreContext.Provider>;
};

export const useStore = <T = Store,>(selector?: (store: Store) => T): T => {
  const appStoreContext = useContext(AppStoreContext);

  if (!appStoreContext) {
    throw new Error('useStore must be use within AppStoreProvider');
  }
  const defaultSelector = useShallow((state: Store) => state as T);
  return useZustandStore(appStoreContext, selector || defaultSelector);
};
